import { authApiService } from '../../authApiService';
import { ApiResponseType, AuthResponseType } from '@/types/sharedTypes';

export const completeRegistrationApi = async (data): Promise<ApiResponseType<AuthResponseType>> => {
  const uri = '/users/auth/complete-registration/';

  return authApiService.POST(uri, data);
};
